"use strict";
/* eslint-disable import/no-duplicates */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFromUrqlClient = exports.createFromApolloClient = void 0;
const react_1 = require("react");
function createFromApolloClient(apolloModule, client) {
    return {
        useQuery: (query, opts = {}) => {
            const { data, loading, error } = apolloModule.useQuery(apolloModule.gql(query), {
                variables: opts.variables,
                skip: opts.skip,
                client,
            });
            return { data, loading, error };
        },
        useMutation: (mutation) => {
            const [func, { loading, error }] = apolloModule.useMutation(apolloModule.gql(mutation), {
                client,
            });
            return [func, { loading, error }];
        },
        query: async (query, variables) => await client.query({
            query: apolloModule.gql(query),
            variables,
        }),
    };
}
exports.createFromApolloClient = createFromApolloClient;
function createFromUrqlClient({ urqlModule, client, url, fetchOptions, }) {
    return {
        useQuery: (query, opts) => {
            const [{ data, fetching, error }] = urqlModule.useQuery({
                query: query,
                variables: opts.variables,
                pause: opts.skip,
                context: (0, react_1.useMemo)(() => ({
                    url,
                    fetchOptions,
                }), []),
            });
            (0, react_1.useEffect)(() => {
                if (error) {
                    console.error(error);
                }
            }, [error]);
            return { data: data, loading: fetching, error };
        },
        useMutation: (mutation) => {
            const [{ fetching, error }, func] = urqlModule.useMutation(mutation);
            const context = (0, react_1.useMemo)(() => ({
                url,
                fetchOptions,
            }), []);
            return [
                async ({ variables }) => {
                    const r = await func(variables, context);
                    return { data: r.data };
                },
                { loading: fetching, error },
            ];
        },
        query: async (query, { variables }) => {
            const result = await client.query(query, variables);
            return { data: result.data };
        },
    };
}
exports.createFromUrqlClient = createFromUrqlClient;
